import React from "react";

const Footer = () => (
  <footer className="app-footer">
    <span>© {new Date().getFullYear()} Wideby</span>
    <span className="app-footer-sep">·</span>
    <a href="#">Privacy Policy</a>
  </footer>
);

export default Footer;
